import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { 
  Menu, 
  X, 
  CheckCircle, 
  HelpCircle, 
  Clock, 
  ShieldAlert,
  MessageSquare,
  Palette,
  FileCheck,
  Truck,
  Star,
  Eye,
  DollarSign,
  Package,
  Wrench,
  Award,
  Phone,
  MapPin,
  Mail,
  Facebook,
  Instagram,
  Linkedin,
  ArrowRight,
  Check,
  Minus,
  Users,
  Target,
  Heart,
  Cpu,
  FileSearch,
  CreditCard,
  Home as HomeIcon,
  Headphones,
  Settings,
  ChevronDown,
  ChevronUp,
  Youtube,
  Shield,
  BadgeCheck
} from "lucide-react";
import { Link, useLocation } from "react-router-dom";

// Design system images from design_guidelines.json
const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/dc451220-fd7c-408e-8216-63870750b6c9/images/b61e5f195c7460b771fec16cfd0fdd042fa2471727daa8040b0665bd9bb0156a.png",
  transformation: "https://static.prod-images.emergentagent.com/jobs/dc451220-fd7c-408e-8216-63870750b6c9/images/d525a5dcac1424ae68ab420d0169a473b0cf07b3a49b24ff89e00aede7ea8811.png",
  kitchen1: "https://images.unsplash.com/photo-1639751787355-bbc3ed1fd639?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjBraXRjaGVuJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc1NzM1NzY5fDA&ixlib=rb-4.1.0&q=85",
  wardrobe1: "https://images.unsplash.com/photo-1649361811423-a55616f7ab11?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxwcmVtaXVtJTIwY3VzdG9tJTIwd2FyZHJvYmUlMjBjbG9zZXR8ZW58MHx8fHwxNzc1NzM1NzY5fDA&ixlib=rb-4.1.0&q=85",
  tvConsole1: "https://images.unsplash.com/photo-1761330440311-16e160cad236?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjB0diUyMGNvbnNvbGUlMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc3NTczNTc2OXww&ixlib=rb-4.1.0&q=85",
  kitchen2: "https://images.unsplash.com/photo-1643034738686-d69e7bc047e1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBraXRjaGVuJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc1NzM1NzY5fDA&ixlib=rb-4.1.0&q=85",
  wardrobe2: "https://images.unsplash.com/photo-1618236444721-4a8dba415c15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwY3VzdG9tJTIwd2FyZHJvYmUlMjBjbG9zZXR8ZW58MHx8fHwxNzc1NzM1NzY5fDA&ixlib=rb-4.1.0&q=85",
  tvConsole2: "https://images.unsplash.com/photo-1774301266018-57c0b190ed43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjB0diUyMGNvbnNvbGUlMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc3NTczNTc2OXww&ixlib=rb-4.1.0&q=85",
  testimonial1: "https://images.unsplash.com/photo-1655249493799-9cee4fe983bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMHBvcnRyYWl0JTIwcHJvZmVzc2lvbmFsJTIwaGVhZHNob3R8ZW58MHx8fHwxNzc1NzM1Nzg2fDA&ixlib=rb-4.1.0&q=85",
  testimonial2: "https://images.unsplash.com/photo-1576558656222-ba66febe3dec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHBvcnRyYWl0JTIwcHJvZmVzc2lvbmFsJTIwaGVhZHNob3R8ZW58MHx8fHwxNzc1NzM1Nzg2fDA&ixlib=rb-4.1.0&q=85",
  testimonial3: "https://images.unsplash.com/photo-1689600944138-da3b150d9cb8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHBvcnRyYWl0JTIwcHJvZmVzc2lvbmFsJTIwaGVhZHNob3R8ZW58MHx8fHwxNzc1NzM1Nzg2fDA&ixlib=rb-4.1.0&q=85",
  // About page images
  workshop: "https://images.unsplash.com/photo-1682718619781-252f23e21132?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBmdXJuaXR1cmUlMjB3b3Jrc2hvcCUyMGZhY3RvcnklMjBjcmFmdHNtYW58ZW58MHx8fHwxNzc1NzM2NDY1fDA&ixlib=rb-4.1.0&q=85",
  founder: "https://images.unsplash.com/photo-1600896997793-b8ed3459a17f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxhc2lhbiUyMHByb2Zlc3Npb25hbCUyMGVudHJlcHJlbmV1ciUyMGZvdW5kZXIlMjBwb3J0cmFpdHxlbnwwfHx8fDE3NzU3MzY0NjZ8MA&ixlib=rb-4.1.0&q=85",
  lifestyle: "https://images.unsplash.com/photo-1628744876525-f2678d8af47f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjBsaXZpbmclMjByb29tJTIwaW50ZXJpb3IlMjBkZXNpZ258ZW58MHx8fHwxNzc1NzM2NDY1fDA&ixlib=rb-4.1.0&q=85",
};

// Logo Component
const Logo = ({ className = "", size = 40 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 1500 1500" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_logo)">
      <path d="M514.942 468.112L815.936 467.503C855.163 467.439 973.874 459.336 1011.28 482.712C1018.99 487.533 1028.91 529.246 1029.16 540.491C1032.37 688.468 1033.11 838.637 1027.55 986.583C1026.9 1004.02 1009.52 1015.08 996.492 1024.18C913.378 1024.55 558.804 1036.14 510.644 1020.69C498.194 1016.7 488.203 1007.48 482.332 995.868C474.893 981.159 473.855 961.97 473.004 945.82C470.605 900.212 469.66 529.043 477.891 504.45C484.612 484.365 497.116 476.981 514.942 468.112Z" fill="#C8A74D"/>
      <path d="M342.21 0C357.666 0.148959 365.605 -1.01633 378.128 8.4834C398.615 34.6933 389.276 109.448 388.826 147.511C393.372 147.454 397.918 147.423 402.458 147.417L970.619 146.812C1064.05 146.764 1163.68 142.717 1256.29 152.93C1292.48 156.921 1345.19 209.083 1347.84 245.78C1354.57 338.892 1351.89 435.311 1351.84 529.087L1351.83 1117.49C1351.64 1273.85 1358.92 1349.88 1171.58 1347.81L1171.58 1436.54C1266.88 1436.63 1365.12 1433.33 1460.3 1436.91C1482.77 1437.75 1485.29 1442.6 1497.78 1457.56C1500.73 1475.55 1502.17 1469.06 1492.68 1483.75C1463.44 1502.16 1393.88 1495.93 1356.59 1495.17C1294.8 1494.65 1234.07 1494.8 1172.44 1499.05C1160.9 1500.16 1139.25 1496.21 1131.72 1486.74C1107.66 1456.44 1115.73 1385.29 1116.46 1347.89L549.831 1348.09C460.228 1348.13 370.753 1349.58 281.124 1346.19C223.527 1344.02 159.489 1301.8 154.425 1240.83C147.245 1154.38 150.712 1061.83 150.758 974.357L151.229 382.561C121.001 383.194 3.02649 391.667 0 350.993C25.9438 319.476 111.913 326.469 151.116 327.296C150.948 320.011 150.86 312.72 150.854 305.43C150.85 171.625 213.117 146.54 332.641 147.102C331.942 109.539 326.342 29.1394 342.21 0ZM1247.1 243.875C1203.04 230.815 995.127 235.446 931.193 235.484L389.369 235.631C390.235 404.151 401.932 381.384 241.585 382.487L241.354 914.827C241.337 986.113 233.281 1193.54 255.207 1245.43C277.139 1264.91 529.382 1257.64 572.522 1257.61L1116.39 1257.4C1116.18 1219.63 1113.97 1151.91 1119.36 1116.99C1134.38 1112.31 1141.31 1108.82 1156.17 1114.74C1184.8 1138.07 1170.85 1220.02 1171.55 1257.29C1194.93 1257.81 1237.96 1263.01 1253.98 1243.9C1263.39 1232.69 1263 1195.8 1263 1180.55C1262.98 893.322 1264.57 605.996 1262.15 318.799C1262.01 302.342 1256.59 255.627 1247.1 243.875ZM270.614 235.875C232.981 258.199 240.419 287.925 241.364 327.208L306.786 327.169C312.736 326.724 324.645 327.164 327.135 323.496C339.759 304.906 332.016 259.674 332.729 235.991L270.614 235.875Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_logo">
        <rect width="1500" height="1500" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

// Navigation Component
const Navigation = ({ scrolled, mobileMenuOpen, setMobileMenuOpen }) => {
  const location = useLocation();
  const navLinks = [
    { name: "Home", href: "/" },
    { name: "About", href: "/about" },
    { name: "Products", href: "/products" },
    { name: "Partner With Us", href: "/partner" },
    { name: "Contact Us", href: "/contact" },
  ];

  return (
    <>
      <nav 
        data-testid="navigation"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'nav-solid' : 'nav-transparent'
        }`}
      >
        <div className="container-custom">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" data-testid="logo" className="flex items-center gap-2 text-white">
              <Logo size={44} className="text-white" />
              <span className="font-serif text-2xl font-bold tracking-tight hidden sm:inline">FITTED</span>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  data-testid={`nav-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                  className={`text-sm font-medium transition-colors ${
                    location.pathname === link.href 
                      ? 'text-[#C9A84C]' 
                      : 'text-white hover:text-[#C9A84C]'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <button 
                data-testid="nav-cta-button"
                className="btn-primary text-sm"
              >
                Get Free Quote
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              data-testid="mobile-menu-button"
              className="lg:hidden text-[#C9A84C] p-2"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div className="mobile-menu-overlay lg:hidden" data-testid="mobile-menu">
          <button
            className="absolute top-6 right-6 text-[#C9A84C]"
            onClick={() => setMobileMenuOpen(false)}
          >
            <X size={32} />
          </button>
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.href}
              className="mobile-menu-link"
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.name}
            </Link>
          ))}
          <button className="btn-primary mt-4">Get Free Quote</button>
        </div>
      )}
    </>
  );
};

// Section 1: Hero Banner
const HeroSection = () => {
  return (
    <section data-testid="hero-section" className="hero-section">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${IMAGES.hero})` }}
      />
      {/* Overlay */}
      <div className="hero-overlay" />
      
      {/* Content */}
      <div className="container-custom relative z-10 text-center text-white pt-20">
        <h1 
          data-testid="hero-headline"
          className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 animate-fade-in-up tracking-tight"
        >
          Custom Furniture. Perfectly Fitted.
        </h1>
        <p 
          data-testid="hero-subheadline"
          className="text-lg sm:text-xl text-gray-200 mb-10 max-w-2xl mx-auto animate-fade-in-up animation-delay-100"
        >
          Malaysia's first tech-enabled custom furniture brand. Design it. See it. Own it.
        </p>
        
        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up animation-delay-200">
          <button data-testid="hero-cta-primary" className="btn-primary">
            Get Your Free Quote
            <ArrowRight size={18} />
          </button>
          <button data-testid="hero-cta-secondary" className="btn-ghost">
            See Our Work
          </button>
        </div>

        {/* Trust Badges */}
        <div 
          data-testid="trust-badges"
          className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12 mt-16 animate-fade-in-up animation-delay-300"
        >
          <div className="trust-badge">
            <CheckCircle size={20} className="text-[#C9A84C]" />
            <span>500+ Projects Completed</span>
          </div>
          <div className="trust-badge">
            <Star size={20} className="text-[#C9A84C]" fill="#C9A84C" />
            <span>4.9★ Google Rating</span>
          </div>
          <div className="trust-badge">
            <Clock size={20} className="text-[#C9A84C]" />
            <span>3–5 Week Delivery</span>
          </div>
        </div>
      </div>
    </section>
  );
};

// Section 2: The Problem We Solve
const ProblemSection = () => {
  const painPoints = [
    {
      icon: <HelpCircle size={28} />,
      title: "No Clear Pricing",
      description: "Hidden costs and confusing quotes make budgeting impossible."
    },
    {
      icon: <Eye size={28} />,
      title: "No Visualization",
      description: "Can't see what you're getting until it's already built."
    },
    {
      icon: <Clock size={28} />,
      title: "Long Wait Times",
      description: "Months of waiting with no clear timeline or updates."
    },
    {
      icon: <ShieldAlert size={28} />,
      title: "No Accountability",
      description: "When things go wrong, there's no one to turn to."
    }
  ];

  return (
    <section data-testid="problem-section" className="section-padding bg-[#F8F6F1]">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: Text Content */}
          <div>
            <div className="gold-line mb-6" />
            <h2 
              data-testid="problem-headline"
              className="font-serif text-3xl sm:text-4xl lg:text-[44px] text-[#1A1F3D] font-bold mb-6 leading-tight"
            >
              Tired of Furniture Guesswork?
            </h2>
            <p className="text-[#2B2D42] text-lg mb-8 leading-relaxed">
              Most custom furniture experiences are frustrating. We're here to change that.
            </p>
            <button data-testid="problem-cta" className="btn-secondary">
              See How FITTED Is Different
            </button>
          </div>

          {/* Right: Pain Point Cards */}
          <div className="grid sm:grid-cols-2 gap-5">
            {painPoints.map((point, index) => (
              <div 
                key={index}
                data-testid={`pain-card-${index}`}
                className="pain-card"
              >
                <div className="text-[#C9A84C] mb-4">{point.icon}</div>
                <h3 className="font-serif text-lg text-[#1A1F3D] font-bold mb-2">
                  {point.title}
                </h3>
                <p className="text-[#8D99AE] text-sm leading-relaxed">
                  {point.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

// Section 3: How It Works
const HowItWorksSection = () => {
  const steps = [
    {
      number: 1,
      title: "Tell Us What You Need",
      description: "Share your vision via our form or WhatsApp"
    },
    {
      number: 2,
      title: "We Design It in 3D",
      description: "Free visualization before you commit"
    },
    {
      number: 3,
      title: "Confirm & We Build It",
      description: "Transparent pricing, no hidden costs"
    },
    {
      number: 4,
      title: "We Install, You Enjoy",
      description: "Professional installation in 3–5 weeks"
    }
  ];

  return (
    <section data-testid="how-it-works-section" className="section-padding bg-white">
      <div className="container-custom">
        <div className="text-center mb-16">
          <div className="gold-line mx-auto mb-6" />
          <h2 
            data-testid="how-it-works-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-[44px] text-[#1A1F3D] font-bold"
          >
            4 Simple Steps to Your Dream Furniture
          </h2>
        </div>

        {/* Steps */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
          {steps.map((step, index) => (
            <div 
              key={index}
              data-testid={`step-${step.number}`}
              className="text-center relative"
            >
              {/* Connector Line (hidden on mobile and last item) */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-7 left-[60%] w-[80%] h-[2px] bg-[#EAEAEA]" />
              )}
              
              <div className="step-circle mx-auto mb-6 relative z-10">
                {step.number}
              </div>
              <h3 className="font-serif text-lg text-[#1A1F3D] font-bold mb-3">
                {step.title}
              </h3>
              <p className="text-[#8D99AE] text-sm leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Section 4: Featured Products
const FeaturedProductsSection = () => {
  const products = [
    { name: "Wardrobes", image: IMAGES.wardrobe1 },
    { name: "Kitchen Cabinets", image: IMAGES.kitchen1 },
    { name: "TV Consoles", image: IMAGES.tvConsole1 },
    { name: "Shoe Cabinets", image: IMAGES.wardrobe2 },
    { name: "Home Office", image: IMAGES.kitchen2 },
    { name: "Commercial Fit-outs", image: IMAGES.tvConsole2 }
  ];

  return (
    <section data-testid="products-section" id="products" className="section-padding bg-[#F8F6F1]">
      <div className="container-custom">
        <div className="text-center mb-16">
          <div className="gold-line mx-auto mb-6" />
          <h2 
            data-testid="products-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-[44px] text-[#1A1F3D] font-bold"
          >
            What We Build
          </h2>
        </div>

        {/* Product Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map((product, index) => (
            <div 
              key={index}
              data-testid={`product-card-${index}`}
              className="product-card"
            >
              <img 
                src={product.image} 
                alt={product.name}
                loading="lazy"
              />
              <div className="product-card-overlay">
                <h3 className="font-serif text-xl text-white font-bold">
                  {product.name}
                </h3>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <button data-testid="products-cta" className="btn-primary">
            Explore All Products
            <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
};

// Section 5: Before & After Showcase
const BeforeAfterSection = () => {
  return (
    <section data-testid="before-after-section" className="section-padding bg-[#1A1F3D]">
      <div className="container-custom">
        <div className="text-center mb-16">
          <div className="gold-line mx-auto mb-6" />
          <h2 
            data-testid="before-after-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-[44px] text-white font-bold"
          >
            See the FITTED Difference
          </h2>
        </div>

        {/* Before/After Image */}
        <div className="max-w-4xl mx-auto">
          <div className="before-after-container rounded-2xl overflow-hidden shadow-2xl">
            <img 
              src={IMAGES.transformation}
              alt="Before and After Transformation"
              className="w-full h-auto"
              data-testid="transformation-image"
            />
          </div>
          
          {/* Labels */}
          <div className="flex justify-between mt-6 text-white">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-[#8D99AE]" />
              <span className="text-sm text-[#8D99AE]">Before</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-[#C9A84C]" />
              <span className="text-sm text-[#C9A84C]">After</span>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <button data-testid="before-after-cta" className="btn-ghost">
            View Full Portfolio
          </button>
        </div>
      </div>
    </section>
  );
};

// Section 6: Testimonials
const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Sarah Tan",
      location: "Kuala Lumpur",
      image: IMAGES.testimonial1,
      quote: "FITTED transformed our master bedroom with a stunning built-in wardrobe. The 3D preview was exactly what we got. Absolutely impressed!",
      rating: 5
    },
    {
      name: "David Lim",
      location: "Petaling Jaya",
      image: IMAGES.testimonial2,
      quote: "Professional, transparent, and delivered on time. Our kitchen cabinets are perfect. Highly recommend FITTED to anyone.",
      rating: 5
    },
    {
      name: "Aisha Rahman",
      location: "Shah Alam",
      image: IMAGES.testimonial3,
      quote: "Finally, a furniture company that actually listens! The team was responsive and the quality exceeded our expectations.",
      rating: 5
    }
  ];

  return (
    <section data-testid="testimonials-section" className="section-padding bg-white">
      <div className="container-custom">
        <div className="text-center mb-16">
          <div className="gold-line mx-auto mb-6" />
          <h2 
            data-testid="testimonials-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-[44px] text-[#1A1F3D] font-bold"
          >
            What Our Clients Say
          </h2>
        </div>

        {/* Testimonial Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              data-testid={`testimonial-card-${index}`}
              className="testimonial-card"
            >
              {/* Stars */}
              <div className="star-rating mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={18} />
                ))}
              </div>
              
              {/* Quote */}
              <p className="text-[#2B2D42] mb-6 leading-relaxed">
                "{testimonial.quote}"
              </p>
              
              {/* Author */}
              <div className="flex items-center gap-4">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <h4 className="font-bold text-[#1A1F3D]">{testimonial.name}</h4>
                  <p className="text-sm text-[#8D99AE]">{testimonial.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Row */}
        <div 
          data-testid="trust-row"
          className="flex flex-wrap justify-center items-center gap-8 sm:gap-16 mt-16 pt-12 border-t border-[#EAEAEA]"
        >
          <div className="text-center">
            <div className="flex items-center justify-center gap-2 mb-2">
              <img 
                src="https://www.google.com/favicon.ico" 
                alt="Google" 
                className="w-5 h-5"
              />
              <span className="font-bold text-[#1A1F3D]">4.9</span>
              <div className="star-rating">
                <Star size={14} />
              </div>
            </div>
            <p className="text-xs text-[#8D99AE]">Google Reviews</p>
          </div>
          <div className="text-center">
            <p className="font-serif text-3xl text-[#1A1F3D] font-bold">500+</p>
            <p className="text-xs text-[#8D99AE]">Projects Completed</p>
          </div>
          <div className="text-center">
            <p className="font-serif text-3xl text-[#1A1F3D] font-bold">98%</p>
            <p className="text-xs text-[#8D99AE]">Satisfaction Rate</p>
          </div>
        </div>
      </div>
    </section>
  );
};

// Section 7: Why Choose FITTED
const WhyChooseSection = () => {
  const features = [
    {
      icon: <DollarSign size={28} />,
      title: "Transparent Pricing",
      description: "No hidden costs. What you see is what you pay."
    },
    {
      icon: <Palette size={28} />,
      title: "3D Visualization",
      description: "See your furniture before it's built."
    },
    {
      icon: <Truck size={28} />,
      title: "3–5 Week Delivery",
      description: "Fast turnaround without compromising quality."
    },
    {
      icon: <Package size={28} />,
      title: "Premium Materials",
      description: "Only the finest materials for lasting quality."
    },
    {
      icon: <Wrench size={28} />,
      title: "Professional Installation",
      description: "Expert fitting by our trained team."
    },
    {
      icon: <Award size={28} />,
      title: "After-Sales Warranty",
      description: "Peace of mind with our warranty coverage."
    }
  ];

  return (
    <section data-testid="why-choose-section" className="section-padding bg-[#F8F6F1]">
      <div className="container-custom">
        <div className="text-center mb-16">
          <div className="gold-line mx-auto mb-6" />
          <h2 
            data-testid="why-choose-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-[44px] text-[#1A1F3D] font-bold"
          >
            Why Homeowners Trust FITTED
          </h2>
        </div>

        {/* Feature Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div 
              key={index}
              data-testid={`feature-card-${index}`}
              className="feature-card bg-white rounded-2xl"
            >
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3 className="font-serif text-lg text-[#1A1F3D] font-bold mb-2">
                {feature.title}
              </h3>
              <p className="text-[#8D99AE] text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Section 8: Final CTA Banner
const FinalCTASection = () => {
  return (
    <section data-testid="final-cta-section" className="relative">
      {/* Gold accent line on top */}
      <div className="gold-line-full" />
      
      <div className="bg-[#1A1F3D] py-20 sm:py-24">
        <div className="container-custom text-center">
          <h2 
            data-testid="final-cta-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white font-bold mb-6"
          >
            Ready to Build Your Dream Space?
          </h2>
          <p className="text-[#8D99AE] text-lg mb-10 max-w-2xl mx-auto">
            Get a free consultation and 3D design preview. No obligation.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button data-testid="final-cta-primary" className="btn-primary text-base">
              Get Your Free Quote Now
              <ArrowRight size={20} />
            </button>
            <button data-testid="final-cta-whatsapp" className="btn-ghost">
              <MessageSquare size={20} />
              WhatsApp Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

// Footer
const Footer = () => {
  const quickLinks = [
    { name: "Home", href: "#" },
    { name: "About Us", href: "#about" },
    { name: "Products", href: "#products" },
    { name: "Portfolio", href: "#portfolio" },
    { name: "Contact", href: "#contact" }
  ];

  return (
    <footer data-testid="footer" className="bg-[#1A1F3D]">
      {/* Gold accent line */}
      <div className="gold-line-full" />
      
      <div className="container-custom py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Tagline */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <Logo size={40} className="text-white" />
              <span className="font-serif text-2xl text-white font-bold">FITTED</span>
            </div>
            <p className="text-[#8D99AE] text-sm leading-relaxed mb-6">
              Malaysia's first tech-enabled custom furniture brand. Design it. See it. Own it.
            </p>
            <div className="flex gap-4">
              <a 
                href="#" 
                className="w-10 h-10 rounded-full bg-[#2B2D42] flex items-center justify-center text-white hover:bg-[#C9A84C] transition-colors"
                data-testid="social-facebook"
              >
                <Facebook size={18} />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 rounded-full bg-[#2B2D42] flex items-center justify-center text-white hover:bg-[#C9A84C] transition-colors"
                data-testid="social-instagram"
              >
                <Instagram size={18} />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 rounded-full bg-[#2B2D42] flex items-center justify-center text-white hover:bg-[#C9A84C] transition-colors"
                data-testid="social-linkedin"
              >
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-white mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a 
                    href={link.href}
                    className="text-[#8D99AE] text-sm hover:text-[#C9A84C] transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-white mb-6">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#C9A84C] flex-shrink-0 mt-1" />
                <span className="text-[#8D99AE] text-sm">
                  Industrial Park, 5, Jalan Satria 16,<br />
                  Taman Perindustrian Jb Perdana,<br />
                  81300 Skudai, Johor
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-[#C9A84C]" />
                <a href="tel:+60167882088" className="text-[#8D99AE] text-sm hover:text-[#C9A84C] transition-colors">
                  +60 16-788 2088
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-[#C9A84C]" />
                <a href="mailto:hello@fitted.diy" className="text-[#8D99AE] text-sm hover:text-[#C9A84C] transition-colors">
                  hello@fitted.diy
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter / CTA */}
          <div>
            <h4 className="font-bold text-white mb-6">Get Started</h4>
            <p className="text-[#8D99AE] text-sm mb-4">
              Ready to transform your space? Get a free quote today.
            </p>
            <button data-testid="footer-cta" className="btn-primary w-full text-sm">
              Get Free Quote
            </button>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#2B2D42] mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-[#8D99AE] text-sm">
            © 2026 FITTED. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy-policy" className="text-[#8D99AE] text-sm hover:text-[#C9A84C] transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-[#8D99AE] text-sm hover:text-[#C9A84C] transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

// WhatsApp Floating Button
const WhatsAppButton = () => {
  return (
    <a 
      href="https://wa.me/60167882088"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      className="whatsapp-button"
      aria-label="Chat on WhatsApp"
    >
      <svg viewBox="0 0 24 24" width="32" height="32" fill="white">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    </a>
  );
};

// Home Page Component
const Home = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div data-testid="home-page">
      <Navigation 
        scrolled={scrolled} 
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />
      <HeroSection />
      <ProblemSection />
      <HowItWorksSection />
      <FeaturedProductsSection />
      <BeforeAfterSection />
      <TestimonialsSection />
      <WhyChooseSection />
      <FinalCTASection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

// ==================== ABOUT PAGE COMPONENTS ====================

// About Section 1: Hero
const AboutHeroSection = () => {
  return (
    <section 
      data-testid="about-hero-section" 
      className="relative min-h-[50vh] flex items-center justify-center bg-[#1A1F3D]"
    >
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-30"
        style={{ backgroundImage: `url(${IMAGES.workshop})`, filter: 'blur(2px)' }}
      />
      
      {/* Content */}
      <div className="container-custom relative z-10 text-center text-white pt-20 py-20">
        <h1 
          data-testid="about-hero-headline"
          className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 animate-fade-in-up tracking-tight"
        >
          We're Building the Future of Custom Furniture
        </h1>
        <p 
          data-testid="about-hero-subheadline"
          className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto animate-fade-in-up animation-delay-100"
        >
          Tech-enabled. Design-led. Perfectly fitted to your space.
        </p>
      </div>
    </section>
  );
};

// About Section 2: Our Story
const OurStorySection = () => {
  return (
    <section data-testid="our-story-section" className="section-padding bg-white">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: Text Content */}
          <div>
            <div className="gold-line mb-6" />
            <h2 
              data-testid="our-story-headline"
              className="font-serif text-3xl sm:text-4xl lg:text-[44px] text-[#1A1F3D] font-bold mb-6 leading-tight"
            >
              Why FITTED Exists
            </h2>
            <div className="text-[#2B2D42] space-y-4 leading-relaxed">
              <p>
                It all started with a frustrating renovation. Our founder spent months dealing with carpenters 
                who gave vague quotes, missed deadlines, and delivered furniture that didn't match expectations. 
                There had to be a better way.
              </p>
              <p>
                That's why FITTED was born—to bring transparency, technology, and trust to the custom furniture 
                industry. We believe that every Malaysian homeowner deserves to see exactly what they're getting, 
                know exactly what they're paying, and receive their furniture on time.
              </p>
              <p>
                Today, FITTED combines cutting-edge 3D visualization with master craftsmanship to deliver 
                custom furniture that's perfectly fitted to your space and your life. No guesswork. No surprises. 
                Just beautiful furniture, built for you.
              </p>
            </div>
          </div>

          {/* Right: Image */}
          <div className="relative">
            <img 
              src={IMAGES.lifestyle}
              alt="FITTED Lifestyle"
              className="rounded-2xl shadow-2xl w-full h-auto object-cover"
              data-testid="our-story-image"
            />
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-[#C9A84C] rounded-2xl -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
};

// About Section 3: Mission & Values
const MissionValuesSection = () => {
  const values = [
    {
      number: "01",
      title: "Radical Transparency",
      description: "No hidden costs, ever. What you see is what you pay."
    },
    {
      number: "02",
      title: "Craftsmanship Meets Technology",
      description: "Precision at every step, from 3D design to final installation."
    },
    {
      number: "03",
      title: "Customer First",
      description: "Your space, your vision, our obsession."
    }
  ];

  return (
    <section data-testid="mission-values-section" className="section-padding bg-[#F8F6F1]">
      <div className="container-custom">
        <div className="text-center mb-16">
          <div className="gold-line mx-auto mb-6" />
          <h2 
            data-testid="mission-values-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-[44px] text-[#1A1F3D] font-bold"
          >
            What We Stand For
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div 
              key={index}
              data-testid={`value-card-${index}`}
              className="bg-white rounded-2xl p-8 shadow-lg text-center"
            >
              <span className="font-serif text-5xl text-[#C9A84C] font-bold block mb-4">
                {value.number}
              </span>
              <h3 className="font-serif text-xl text-[#1A1F3D] font-bold mb-3">
                {value.title}
              </h3>
              <p className="text-[#8D99AE] leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// About Section 4: Comparison Table
const ComparisonSection = () => {
  const features = [
    { name: "Pricing Transparency", fitted: true, traditional: false, readyMade: true },
    { name: "3D Preview", fitted: true, traditional: false, readyMade: false },
    { name: "Lead Time", fittedText: "3-5 Weeks", traditionalText: "8-12 Weeks", readyMadeText: "Immediate" },
    { name: "Quality Guarantee", fitted: true, traditional: false, readyMade: true },
    { name: "After-Sales Support", fitted: true, traditional: false, readyMade: true },
    { name: "Custom Sizing", fitted: true, traditional: true, readyMade: false },
    { name: "Technology Integration", fitted: true, traditional: false, readyMade: false },
  ];

  const renderCell = (value, isText) => {
    if (isText) return <span className="text-[#2B2D42] text-sm">{value}</span>;
    return value ? (
      <Check className="text-[#C9A84C] mx-auto" size={24} />
    ) : (
      <Minus className="text-[#8D99AE] mx-auto" size={24} />
    );
  };

  return (
    <section data-testid="comparison-section" className="section-padding bg-white">
      <div className="container-custom">
        <div className="text-center mb-16">
          <div className="gold-line mx-auto mb-6" />
          <h2 
            data-testid="comparison-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-[44px] text-[#1A1F3D] font-bold"
          >
            How We're Different
          </h2>
          <p className="text-[#8D99AE] mt-4 max-w-2xl mx-auto">
            The FITTED Advantage vs. other furniture options
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full min-w-[600px]" data-testid="comparison-table">
            <thead>
              <tr>
                <th className="text-left py-4 px-4 text-[#8D99AE] font-medium text-sm"></th>
                <th className="py-4 px-4 bg-[#1A1F3D] rounded-t-xl">
                  <span className="text-white font-bold text-lg">FITTED</span>
                  <div className="w-8 h-1 bg-[#C9A84C] mx-auto mt-2 rounded" />
                </th>
                <th className="py-4 px-4 text-[#2B2D42] font-bold text-lg">Traditional Carpenters</th>
                <th className="py-4 px-4 text-[#2B2D42] font-bold text-lg">Ready-Made Furniture</th>
              </tr>
            </thead>
            <tbody>
              {features.map((feature, index) => (
                <tr key={index} className="border-b border-[#EAEAEA]">
                  <td className="py-4 px-4 text-[#2B2D42] font-medium">{feature.name}</td>
                  <td className="py-4 px-4 bg-[#1A1F3D]/5 text-center">
                    {feature.fittedText 
                      ? renderCell(feature.fittedText, true) 
                      : renderCell(feature.fitted, false)
                    }
                  </td>
                  <td className="py-4 px-4 text-center">
                    {feature.traditionalText 
                      ? renderCell(feature.traditionalText, true) 
                      : renderCell(feature.traditional, false)
                    }
                  </td>
                  <td className="py-4 px-4 text-center">
                    {feature.readyMadeText 
                      ? renderCell(feature.readyMadeText, true) 
                      : renderCell(feature.readyMade, false)
                    }
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

// About Section 5: Our Process
const OurProcessSection = () => {
  const steps = [
    {
      number: 1,
      title: "Free Consultation",
      description: "Tell us about your space and vision"
    },
    {
      number: 2,
      title: "3D Design & Quote",
      description: "See your furniture before it's built"
    },
    {
      number: 3,
      title: "Confirmation & Deposit",
      description: "Lock in your design with transparent pricing"
    },
    {
      number: 4,
      title: "Precision Manufacturing",
      description: "Your furniture crafted with care"
    },
    {
      number: 5,
      title: "Professional Installation",
      description: "Expert fitting by our trained team"
    },
    {
      number: 6,
      title: "After-Sales Care",
      description: "We're here for you, always"
    }
  ];

  return (
    <section data-testid="our-process-section" className="section-padding bg-[#1A1F3D]">
      <div className="container-custom">
        <div className="text-center mb-16">
          <div className="gold-line mx-auto mb-6" />
          <h2 
            data-testid="our-process-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-[44px] text-white font-bold"
          >
            From Idea to Installation in 3–5 Weeks
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          {steps.map((step, index) => (
            <div 
              key={index}
              data-testid={`process-step-${index}`}
              className="flex gap-6 mb-8 last:mb-0"
            >
              {/* Timeline */}
              <div className="flex flex-col items-center">
                <div className="step-circle">
                  {step.number}
                </div>
                {index < steps.length - 1 && (
                  <div className="w-[2px] h-16 bg-[#C9A84C]/30 mt-4" />
                )}
              </div>
              
              {/* Content */}
              <div className="pt-3">
                <h3 className="font-serif text-xl text-white font-bold mb-2">
                  {step.title}
                </h3>
                <p className="text-[#8D99AE]">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// About Section 6: Our Numbers
const OurNumbersSection = () => {
  const stats = [
    { value: "500+", label: "Projects Completed" },
    { value: "4.9", label: "Google Rating", suffix: "★" },
    { value: "3-5", label: "Week Average Delivery" },
    { value: "98%", label: "Satisfaction Rate" }
  ];

  return (
    <section data-testid="our-numbers-section" className="section-padding bg-[#F8F6F1]">
      <div className="container-custom">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div 
              key={index}
              data-testid={`stat-${index}`}
              className="text-center"
            >
              <div className="font-serif text-5xl lg:text-6xl text-[#C9A84C] font-bold mb-2">
                {stat.value}{stat.suffix && <span className="text-4xl">{stat.suffix}</span>}
              </div>
              <p className="text-[#2B2D42] font-medium">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// About Section 7: The Team
const TeamSection = () => {
  return (
    <section data-testid="team-section" className="section-padding bg-white">
      <div className="container-custom">
        <div className="text-center mb-16">
          <div className="gold-line mx-auto mb-6" />
          <h2 
            data-testid="team-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-[44px] text-[#1A1F3D] font-bold"
          >
            Meet the Founder
          </h2>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-[#F8F6F1] rounded-2xl p-8 lg:p-12 flex flex-col md:flex-row items-center gap-8">
            <img 
              src={IMAGES.founder}
              alt="Founder"
              className="w-40 h-40 rounded-full object-cover border-4 border-[#C9A84C]"
              data-testid="founder-image"
            />
            <div className="text-center md:text-left">
              <h3 className="font-serif text-2xl text-[#1A1F3D] font-bold mb-1">
                James Wong
              </h3>
              <p className="text-[#C9A84C] font-medium mb-4">Founder & CEO</p>
              <p className="text-[#8D99AE] leading-relaxed">
                After years in the tech industry and a frustrating home renovation experience, 
                James founded FITTED with a simple mission: bring transparency and technology 
                to custom furniture. Today, he leads a team of designers, craftsmen, and 
                technologists committed to transforming how Malaysians furnish their homes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// About Section 8: CTA Banner (reuse FinalCTASection but with different headline)
const AboutCTASection = () => {
  return (
    <section data-testid="about-cta-section" className="relative">
      {/* Gold accent line on top */}
      <div className="gold-line-full" />
      
      <div className="bg-[#1A1F3D] py-20 sm:py-24">
        <div className="container-custom text-center">
          <h2 
            data-testid="about-cta-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white font-bold mb-6"
          >
            Let's Build Something Beautiful Together
          </h2>
          <p className="text-[#8D99AE] text-lg mb-10 max-w-2xl mx-auto">
            Ready to start your custom furniture journey? Get a free consultation today.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button data-testid="about-cta-primary" className="btn-primary text-base">
              Get Your Free Quote
              <ArrowRight size={20} />
            </button>
            <button data-testid="about-cta-whatsapp" className="btn-ghost">
              <MessageSquare size={20} />
              WhatsApp Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

// About Page Component
const About = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div data-testid="about-page">
      <Navigation 
        scrolled={scrolled} 
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />
      <AboutHeroSection />
      <OurStorySection />
      <MissionValuesSection />
      <ComparisonSection />
      <OurProcessSection />
      <OurNumbersSection />
      <TeamSection />
      <AboutCTASection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

// ==================== PRODUCTS PAGE COMPONENTS ====================

// Product page images
const PRODUCT_IMAGES = {
  // Wardrobe images
  wardrobes: [
    "https://images.unsplash.com/photo-1618236444721-4a8dba415c15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjdXN0b20lMjB3YXJkcm9iZSUyMHdhbGstaW4lMjBjbG9zZXQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzU3MzcxNjl8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1630699293155-2cc65a890604?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjdXN0b20lMjB3YXJkcm9iZSUyMHdhbGstaW4lMjBjbG9zZXQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzU3MzcxNjl8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1774301211236-dab64d553241?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBjdXN0b20lMjB3YXJkcm9iZSUyMHdhbGstaW4lMjBjbG9zZXQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzU3MzcxNjl8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1629078691371-2c83d139c986?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBjdXN0b20lMjB3YXJkcm9iZSUyMHdhbGstaW4lMjBjbG9zZXQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzU3MzcxNjl8MA&ixlib=rb-4.1.0&q=85",
  ],
  // Kitchen images
  kitchens: [
    "https://images.unsplash.com/photo-1772567733000-5d5acb9ef4f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBraXRjaGVuJTIwY2FiaW5ldCUyMGludGVyaW9yJTIwZGVzaWduJTIwbHV4dXJ5fGVufDB8fHx8MTc3NTczNzE2OXww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1771862956702-4e8b247e28b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBraXRjaGVuJTIwY2FiaW5ldCUyMGludGVyaW9yJTIwZGVzaWduJTIwbHV4dXJ5fGVufDB8fHx8MTc3NTczNzE2OXww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1772567732993-3c546ee1a52c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBraXRjaGVuJTIwY2FiaW5ldCUyMGludGVyaW9yJTIwZGVzaWduJTIwbHV4dXJ5fGVufDB8fHx8MTc3NTczNzE2OXww&ixlib=rb-4.1.0&q=85",
    "https://images.pexels.com/photos/6264414/pexels-photo-6264414.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ],
  // TV Console images
  tvConsoles: [
    "https://images.unsplash.com/photo-1763827657709-b1bbc3c4945b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjB0diUyMGNvbnNvbGUlMjBsaXZpbmclMjByb29tJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc1NzM3MTY5fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1761330440311-16e160cad236?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjB0diUyMGNvbnNvbGUlMjBsaXZpbmclMjByb29tJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc1NzM3MTY5fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1774301266018-57c0b190ed43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjB0diUyMGNvbnNvbGUlMjBsaXZpbmclMjByb29tJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc1NzM3MTY5fDA&ixlib=rb-4.1.0&q=85",
  ],
  // Shoe Cabinet images
  shoeCabinets: [
    "https://images.unsplash.com/photo-1774271694598-4619fb174764?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBzaG9lJTIwY2FiaW5ldCUyMGVudHJ5d2F5JTIwc3RvcmFnZXxlbnwwfHx8fDE3NzU3MzcxNjl8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1773810773827-91cd658820a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBzaG9lJTIwY2FiaW5ldCUyMGVudHJ5d2F5JTIwc3RvcmFnZXxlbnwwfHx8fDE3NzU3MzcxNjl8MA&ixlib=rb-4.1.0&q=85",
  ],
  // Home Office images
  homeOffice: [
    "https://images.unsplash.com/photo-1737233433647-b53b339306f4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxob21lJTIwb2ZmaWNlJTIwYnVpbHQtaW4lMjBkZXNrJTIwc2hlbHZpbmclMjBtb2Rlcm58ZW58MHx8fHwxNzc1NzM3MTY5fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1772475385509-93fd87a2d4ba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxob21lJTIwb2ZmaWNlJTIwYnVpbHQtaW4lMjBkZXNrJTIwc2hlbHZpbmclMjBtb2Rlcm58ZW58MHx8fHwxNzc1NzM3MTY5fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1764743111075-fb988af9ed75?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHw0fHxob21lJTIwb2ZmaWNlJTIwYnVpbHQtaW4lMjBkZXNrJTIwc2hlbHZpbmclMjBtb2Rlcm58ZW58MHx8fHwxNzc1NzM3MTY5fDA&ixlib=rb-4.1.0&q=85",
  ],
  // Commercial images
  commercial: [
    "https://images.unsplash.com/photo-1758448721205-8465cebc26af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBvZmZpY2UlMjByZWNlcHRpb24lMjBjb3VudGVyJTIwY29tbWVyY2lhbCUyMGludGVyaW9yfGVufDB8fHx8MTc3NTczNzE2OXww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1758448093806-88b2089068ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvZmZpY2UlMjByZWNlcHRpb24lMjBjb3VudGVyJTIwY29tbWVyY2lhbCUyMGludGVyaW9yfGVufDB8fHx8MTc3NTczNzE2OXww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1758448721162-0c77cf477d6f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBvZmZpY2UlMjByZWNlcHRpb24lMjBjb3VudGVyJTIwY29tbWVyY2lhbCUyMGludGVyaW9yfGVufDB8fHx8MTc3NTczNzE2OXww&ixlib=rb-4.1.0&q=85",
  ],
  // Gallery / Portfolio images
  gallery: [
    "https://images.unsplash.com/photo-1765862835282-cd3d9190d246?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBpbnRlcmlvciUyMGRlc2lnbiUyMGxpdmluZyUyMHJvb20lMjBiZWRyb29tJTIwbW9kZXJufGVufDB8fHx8MTc3NTczNzE3N3ww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1765862835326-14b5070fdde9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBpbnRlcmlvciUyMGRlc2lnbiUyMGxpdmluZyUyMHJvb20lMjBiZWRyb29tJTIwbW9kZXJufGVufDB8fHx8MTc3NTczNzE3N3ww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1765862835193-3c37388a409e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBpbnRlcmlvciUyMGRlc2lnbiUyMGxpdmluZyUyMHJvb20lMjBiZWRyb29tJTIwbW9kZXJufGVufDB8fHx8MTc3NTczNzE3N3ww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1770573322210-204dea84450f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxidWlsdC1pbiUyMGZ1cm5pdHVyZSUyMGN1c3RvbSUyMGNhYmluZXQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzU3MzcxNzd8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1567971685846-82fac9a7a5cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxidWlsdC1pbiUyMGZ1cm5pdHVyZSUyMGN1c3RvbSUyMGNhYmluZXQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3NzU3MzcxNzd8MA&ixlib=rb-4.1.0&q=85",
    "https://images.pexels.com/photos/34754004/pexels-photo-34754004.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ],
  // Materials
  materials: [
    "https://images.unsplash.com/photo-1554230253-017daba2b631?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHw0fHx3b29kJTIwdGV4dHVyZSUyMG1hdGVyaWFsJTIwbGFtaW5hdGUlMjB2ZW5lZXIlMjBzYW1wbGV8ZW58MHx8fHwxNzc1NzM3MTc3fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1655457397686-4dd23e78a918?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHx3b29kJTIwdGV4dHVyZSUyMG1hdGVyaWFsJTIwbGFtaW5hdGUlMjB2ZW5lZXIlMjBzYW1wbGV8ZW58MHx8fHwxNzc1NzM3MTc3fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1627608690902-98b7c511181d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHx3b29kJTIwdGV4dHVyZSUyMG1hdGVyaWFsJTIwbGFtaW5hdGUlMjB2ZW5lZXIlMjBzYW1wbGV8ZW58MHx8fHwxNzc1NzM3MTc3fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1607706127558-45c2afcfb72c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHx3b29kJTIwdGV4dHVyZSUyMG1hdGVyaWFsJTIwbGFtaW5hdGUlMjB2ZW5lZXIlMjBzYW1wbGV8ZW58MHx8fHwxNzc1NzM3MTc3fDA&ixlib=rb-4.1.0&q=85",
  ],
};

// Products Section 1: Hero
const ProductsHeroSection = () => {
  return (
    <section data-testid="products-hero-section" className="hero-section">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${IMAGES.hero})` }}
      />
      <div className="hero-overlay" />
      
      <div className="container-custom relative z-10 text-center text-white pt-20">
        <h1 
          data-testid="products-hero-headline"
          className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 animate-fade-in-up tracking-tight"
        >
          Designed for Your Space. Built to Last.
        </h1>
        <p 
          data-testid="products-hero-subheadline"
          className="text-lg sm:text-xl text-gray-200 mb-10 max-w-2xl mx-auto animate-fade-in-up animation-delay-100"
        >
          Browse our custom furniture categories. Every piece made to your exact specifications.
        </p>
        <button data-testid="products-hero-cta" className="btn-primary animate-fade-in-up animation-delay-200">
          Get a Free Quote
          <ArrowRight size={18} />
        </button>
      </div>
    </section>
  );
};

// Products Section 2: Categories Grid
const ProductCategoriesGrid = () => {
  const categories = [
    { 
      name: "Custom Wardrobes", 
      image: PRODUCT_IMAGES.wardrobes[0], 
      id: "wardrobes",
      tagline: "Walk-in closets with LED lighting & smart storage"
    },
    { 
      name: "Kitchen Cabinets", 
      image: PRODUCT_IMAGES.kitchens[0], 
      id: "kitchens",
      tagline: "Modern designs with premium finishes"
    },
    { 
      name: "TV Consoles & Feature Walls", 
      image: PRODUCT_IMAGES.tvConsoles[0], 
      id: "tv-consoles",
      tagline: "Instagram-worthy entertainment centers"
    },
    { 
      name: "Shoe Cabinets & Entryway", 
      image: PRODUCT_IMAGES.shoeCabinets[0], 
      id: "shoe-cabinets",
      tagline: "Slim, elegant storage solutions"
    },
    { 
      name: "Home Office", 
      image: PRODUCT_IMAGES.homeOffice[0], 
      id: "home-office",
      tagline: "Built-in desks & productivity spaces"
    },
    { 
      name: "Commercial & Office", 
      image: PRODUCT_IMAGES.commercial[0], 
      id: "commercial",
      tagline: "Reception counters & workstations"
    },
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section data-testid="product-categories-section" className="section-padding bg-white">
      <div className="container-custom">
        <div className="text-center mb-16">
          <div className="gold-line mx-auto mb-6" />
          <h2 
            data-testid="categories-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-[44px] text-[#1A1F3D] font-bold"
          >
            What We Build
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((category, index) => (
            <div 
              key={index}
              data-testid={`category-card-${index}`}
              className="product-card cursor-pointer"
              onClick={() => scrollToSection(category.id)}
            >
              <img 
                src={category.image} 
                alt={category.name}
                loading="lazy"
              />
              <div className="product-card-overlay">
                <h3 className="font-serif text-xl text-white font-bold mb-1">
                  {category.name}
                </h3>
                <p className="text-gray-300 text-sm">{category.tagline}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Product Showcase Component (reusable for each category)
const ProductShowcase = ({ id, title, projects, bgColor = "bg-white" }) => {
  return (
    <section id={id} data-testid={`${id}-showcase`} className={`section-padding ${bgColor}`}>
      <div className="container-custom">
        <div className="text-center mb-16">
          <div className="gold-line mx-auto mb-6" />
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-[44px] text-[#1A1F3D] font-bold">
            {title}
          </h2>
        </div>

        <div className="space-y-20">
          {projects.map((project, index) => (
            <div 
              key={index}
              className={`grid lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              {/* Image Side */}
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div className="relative">
                  <img 
                    src={project.image}
                    alt={project.title}
                    className="rounded-2xl shadow-xl w-full h-auto object-cover aspect-[4/3]"
                    data-testid={`project-image-${id}-${index}`}
                  />
                  {project.details && project.details.length > 0 && (
                    <div className="grid grid-cols-3 gap-3 mt-4">
                      {project.details.slice(0, 3).map((detail, i) => (
                        <img 
                          key={i}
                          src={detail}
                          alt={`Detail ${i + 1}`}
                          className="rounded-lg h-20 w-full object-cover"
                        />
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Text Side */}
              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <h3 className="font-serif text-2xl text-[#1A1F3D] font-bold mb-4">
                  {project.title}
                </h3>
                <p className="text-[#8D99AE] mb-4 leading-relaxed">
                  {project.description}
                </p>
                <ul className="space-y-2 mb-6">
                  {project.features.map((feature, i) => (
                    <li key={i} className="flex items-center gap-3 text-[#2B2D42]">
                      <Check size={18} className="text-[#C9A84C]" />
                      {feature}
                    </li>
                  ))}
                </ul>
                <p className="text-[#C9A84C] font-serif text-xl font-bold mb-6">
                  {project.price}
                </p>
                <button 
                  data-testid={`get-this-look-${id}-${index}`}
                  className="btn-primary"
                >
                  Get This Look
                  <ArrowRight size={18} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Products Section 3: Wardrobe Showcase
const WardrobeShowcase = () => {
  const projects = [
    {
      image: PRODUCT_IMAGES.wardrobes[0],
      details: PRODUCT_IMAGES.wardrobes.slice(1, 4),
      title: "Modern Walk-In Wardrobe",
      description: "A spacious master bedroom wardrobe with LED lighting, soft-close drawers, and custom shoe racks. Designed to maximize storage while maintaining a clean, luxurious aesthetic.",
      features: ["LED accent lighting", "Soft-close mechanisms", "Custom shoe storage", "Full-length mirror"],
      price: "Starting from RM 8,000"
    },
    {
      image: PRODUCT_IMAGES.wardrobes[2],
      details: [],
      title: "Sliding Door Wardrobe",
      description: "Space-saving sliding door design perfect for bedrooms with limited space. Features full-height storage with dedicated compartments for every item.",
      features: ["Space-saving sliding doors", "Anti-jump track system", "Adjustable shelving", "Integrated tie & belt rack"],
      price: "Starting from RM 6,500"
    },
    {
      image: PRODUCT_IMAGES.wardrobes[3],
      details: [],
      title: "His & Hers Dressing Room",
      description: "A complete dressing room solution with separate zones for two. Includes vanity area, full-length mirrors, and ample hanging space.",
      features: ["Dual zones design", "Built-in vanity area", "Premium hardware", "Customizable layout"],
      price: "Starting from RM 15,000"
    },
  ];

  return <ProductShowcase id="wardrobes" title="Custom Wardrobes" projects={projects} bgColor="bg-[#F8F6F1]" />;
};

// Products Section 4: Kitchen Showcase
const KitchenShowcase = () => {
  const projects = [
    {
      image: PRODUCT_IMAGES.kitchens[0],
      details: PRODUCT_IMAGES.kitchens.slice(1, 4),
      title: "Modern Minimalist Kitchen",
      description: "Clean lines and handleless cabinets create a sleek, contemporary look. Premium laminate finish with quartz countertop and integrated appliances.",
      features: ["Handleless push-to-open", "Quartz countertop", "Soft-close drawers", "Under-cabinet LED lighting"],
      price: "Starting from RM 12,000"
    },
    {
      image: PRODUCT_IMAGES.kitchens[2],
      details: [],
      title: "L-Shaped Kitchen with Island",
      description: "Maximizes corner space with a functional island for extra prep area and casual dining. Features two-tone cabinets for visual interest.",
      features: ["Kitchen island included", "Two-tone cabinet design", "Premium hardware", "Soft-close mechanisms"],
      price: "Starting from RM 18,000"
    },
    {
      image: PRODUCT_IMAGES.kitchens[3],
      details: [],
      title: "Compact Condo Kitchen",
      description: "Designed for Malaysian condos, this compact kitchen maximizes every inch. Features tall cabinets and pull-out organizers.",
      features: ["Space-optimized design", "Pull-out organizers", "Tall storage cabinets", "Easy-clean surfaces"],
      price: "Starting from RM 8,500"
    },
  ];

  return <ProductShowcase id="kitchens" title="Kitchen Cabinets" projects={projects} bgColor="bg-white" />;
};

// Products Section 5: Other Categories Gallery
const OtherCategoriesGallery = () => {
  const categories = [
    {
      id: "tv-consoles",
      title: "TV Consoles & Feature Walls",
      price: "Starting from RM 3,500",
      images: PRODUCT_IMAGES.tvConsoles
    },
    {
      id: "shoe-cabinets",
      title: "Shoe Cabinets & Entryway",
      price: "Starting from RM 2,000",
      images: PRODUCT_IMAGES.shoeCabinets
    },
    {
      id: "home-office",
      title: "Home Office",
      price: "Starting from RM 4,500",
      images: PRODUCT_IMAGES.homeOffice
    },
    {
      id: "commercial",
      title: "Commercial & Office",
      price: "Starting from RM 15,000",
      images: PRODUCT_IMAGES.commercial
    },
  ];

  return (
    <section data-testid="other-categories-section" className="section-padding bg-[#F8F6F1]">
      <div className="container-custom">
        {categories.map((category, catIndex) => (
          <div key={catIndex} id={category.id} className="mb-20 last:mb-0">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-8">
              <div>
                <div className="gold-line mb-4" />
                <h2 className="font-serif text-2xl sm:text-3xl text-[#1A1F3D] font-bold">
                  {category.title}
                </h2>
              </div>
              <p className="text-[#C9A84C] font-serif text-xl font-bold mt-2 sm:mt-0">
                {category.price}
              </p>
            </div>
            
            {/* Horizontal Scrollable Gallery */}
            <div className="flex gap-4 overflow-x-auto pb-4 -mx-4 px-4 scrollbar-hide">
              {category.images.map((image, imgIndex) => (
                <div 
                  key={imgIndex}
                  data-testid={`${category.id}-image-${imgIndex}`}
                  className="flex-shrink-0 w-72 sm:w-80"
                >
                  <img 
                    src={image}
                    alt={`${category.title} ${imgIndex + 1}`}
                    className="rounded-xl w-full h-52 object-cover shadow-lg hover:shadow-xl transition-shadow"
                    loading="lazy"
                  />
                </div>
              ))}
            </div>

            <button 
              data-testid={`get-quote-${category.id}`}
              className="btn-primary mt-6"
            >
              Get This Look
              <ArrowRight size={18} />
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};

// Products Section 6: Materials Library
const MaterialsLibrary = () => {
  const materials = [
    { name: "White Oak Laminate", image: PRODUCT_IMAGES.materials[0] },
    { name: "Walnut Veneer", image: PRODUCT_IMAGES.materials[1] },
    { name: "Grey Ash", image: PRODUCT_IMAGES.materials[2] },
    { name: "Dark Ebony", image: PRODUCT_IMAGES.materials[3] },
    { name: "Soft White", image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=200&fit=crop" },
    { name: "Charcoal Grey", image: "https://images.unsplash.com/photo-1553095066-5ca2a3a79b0f?w=200&h=200&fit=crop" },
    { name: "Natural Maple", image: "https://images.unsplash.com/photo-1541123603104-512919d6a96c?w=200&h=200&fit=crop" },
    { name: "Glossy White", image: "https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=200&h=200&fit=crop" },
    { name: "Brass Hardware", image: "https://images.unsplash.com/photo-1558317374-067fb5f30001?w=200&h=200&fit=crop" },
    { name: "Chrome Hardware", image: "https://images.unsplash.com/photo-1597072689227-8882273e8f6a?w=200&h=200&fit=crop" },
    { name: "Soft-Close Hinges", image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=200&h=200&fit=crop" },
    { name: "LED Lighting", image: "https://images.unsplash.com/photo-1565814329452-e1efa11c5b89?w=200&h=200&fit=crop" },
  ];

  return (
    <section data-testid="materials-section" className="section-padding bg-[#F8F6F1]">
      <div className="container-custom">
        <div className="text-center mb-16">
          <div className="gold-line mx-auto mb-6" />
          <h2 
            data-testid="materials-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-[44px] text-[#1A1F3D] font-bold mb-4"
          >
            Premium Materials. Your Choice.
          </h2>
          <p className="text-[#8D99AE] max-w-2xl mx-auto">
            Every piece built with premium materials and precision hardware.
          </p>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-6">
          {materials.map((material, index) => (
            <div 
              key={index}
              data-testid={`material-${index}`}
              className="text-center group cursor-pointer"
            >
              <div className="relative w-20 h-20 sm:w-24 sm:h-24 mx-auto mb-3 rounded-full overflow-hidden border-2 border-transparent group-hover:border-[#C9A84C] transition-all shadow-md">
                <img 
                  src={material.image}
                  alt={material.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <p className="text-[#2B2D42] text-xs sm:text-sm font-medium">
                {material.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Products Section 7: Portfolio Gallery
const PortfolioGallery = () => {
  const [activeFilter, setActiveFilter] = useState("all");
  
  const allImages = [
    { src: PRODUCT_IMAGES.wardrobes[0], category: "wardrobe" },
    { src: PRODUCT_IMAGES.kitchens[0], category: "kitchen" },
    { src: PRODUCT_IMAGES.tvConsoles[0], category: "living" },
    { src: PRODUCT_IMAGES.wardrobes[1], category: "wardrobe" },
    { src: PRODUCT_IMAGES.kitchens[1], category: "kitchen" },
    { src: PRODUCT_IMAGES.homeOffice[0], category: "office" },
    { src: PRODUCT_IMAGES.gallery[0], category: "living" },
    { src: PRODUCT_IMAGES.wardrobes[2], category: "wardrobe" },
    { src: PRODUCT_IMAGES.kitchens[2], category: "kitchen" },
    { src: PRODUCT_IMAGES.tvConsoles[1], category: "living" },
    { src: PRODUCT_IMAGES.homeOffice[1], category: "office" },
    { src: PRODUCT_IMAGES.gallery[1], category: "living" },
    { src: PRODUCT_IMAGES.wardrobes[3], category: "wardrobe" },
    { src: PRODUCT_IMAGES.kitchens[3], category: "kitchen" },
    { src: PRODUCT_IMAGES.tvConsoles[2], category: "living" },
    { src: PRODUCT_IMAGES.commercial[0], category: "office" },
    { src: PRODUCT_IMAGES.gallery[2], category: "living" },
    { src: PRODUCT_IMAGES.homeOffice[2], category: "office" },
    { src: PRODUCT_IMAGES.gallery[3], category: "wardrobe" },
    { src: PRODUCT_IMAGES.commercial[1], category: "office" },
    { src: PRODUCT_IMAGES.gallery[4], category: "wardrobe" },
    { src: PRODUCT_IMAGES.commercial[2], category: "office" },
    { src: PRODUCT_IMAGES.gallery[5], category: "living" },
    { src: PRODUCT_IMAGES.shoeCabinets[0], category: "living" },
  ];

  const filters = [
    { label: "All", value: "all" },
    { label: "Wardrobe", value: "wardrobe" },
    { label: "Kitchen", value: "kitchen" },
    { label: "Living Room", value: "living" },
    { label: "Office", value: "office" },
  ];

  const filteredImages = activeFilter === "all" 
    ? allImages 
    : allImages.filter(img => img.category === activeFilter);

  return (
    <section data-testid="portfolio-section" className="section-padding bg-[#1A1F3D]">
      <div className="container-custom">
        <div className="text-center mb-12">
          <div className="gold-line mx-auto mb-6" />
          <h2 
            data-testid="portfolio-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-[44px] text-white font-bold mb-4"
          >
            Our Work Speaks for Itself
          </h2>
          
          {/* Filter Tabs */}
          <div className="flex flex-wrap justify-center gap-3 mt-8">
            {filters.map((filter) => (
              <button
                key={filter.value}
                data-testid={`filter-${filter.value}`}
                onClick={() => setActiveFilter(filter.value)}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all ${
                  activeFilter === filter.value
                    ? 'bg-[#C9A84C] text-[#1A1F3D]'
                    : 'bg-[#2B2D42] text-white hover:bg-[#C9A84C] hover:text-[#1A1F3D]'
                }`}
              >
                {filter.label}
              </button>
            ))}
          </div>
        </div>

        {/* Masonry Grid */}
        <div className="columns-2 md:columns-3 lg:columns-4 gap-4 space-y-4">
          {filteredImages.map((image, index) => (
            <div 
              key={index}
              data-testid={`gallery-image-${index}`}
              className="break-inside-avoid group cursor-pointer"
            >
              <img 
                src={image.src}
                alt={`Project ${index + 1}`}
                className="w-full rounded-lg hover:opacity-90 transition-opacity"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Products Section 8: Gold CTA with Form
const ProductsCTASection = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    need: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Handle form submission
    alert('Thank you! We will contact you shortly.');
    setFormData({ name: '', phone: '', need: '' });
  };

  return (
    <section data-testid="products-cta-section" className="py-20 sm:py-24 bg-[#C9A84C]">
      <div className="container-custom text-center">
        <h2 
          data-testid="products-cta-headline"
          className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1A1F3D] font-bold mb-4"
        >
          Your Space Deserves Better
        </h2>
        <p className="text-[#1A1F3D]/80 text-lg mb-10 max-w-2xl mx-auto">
          Tell us your room dimensions. We'll design it in 3D for free. No obligation.
        </p>
        
        {/* Inline Form */}
        <form 
          onSubmit={handleSubmit}
          data-testid="quote-form"
          className="max-w-3xl mx-auto bg-white rounded-2xl p-6 sm:p-8 shadow-xl"
        >
          <div className="grid sm:grid-cols-3 gap-4 mb-6">
            <input
              type="text"
              placeholder="Your Name"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              required
              data-testid="form-name"
              className="px-4 py-3 rounded-lg border border-[#EAEAEA] focus:outline-none focus:border-[#C9A84C] text-[#2B2D42]"
            />
            <input
              type="tel"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={(e) => setFormData({...formData, phone: e.target.value})}
              required
              data-testid="form-phone"
              className="px-4 py-3 rounded-lg border border-[#EAEAEA] focus:outline-none focus:border-[#C9A84C] text-[#2B2D42]"
            />
            <select
              value={formData.need}
              onChange={(e) => setFormData({...formData, need: e.target.value})}
              required
              data-testid="form-need"
              className="px-4 py-3 rounded-lg border border-[#EAEAEA] focus:outline-none focus:border-[#C9A84C] text-[#2B2D42] bg-white"
            >
              <option value="">What do you need?</option>
              <option value="wardrobe">Custom Wardrobe</option>
              <option value="kitchen">Kitchen Cabinets</option>
              <option value="tv-console">TV Console</option>
              <option value="shoe-cabinet">Shoe Cabinet</option>
              <option value="home-office">Home Office</option>
              <option value="commercial">Commercial Fit-out</option>
              <option value="other">Other</option>
            </select>
          </div>
          <button 
            type="submit"
            data-testid="form-submit"
            className="bg-[#1A1F3D] text-white px-8 py-4 rounded-lg font-semibold text-sm uppercase tracking-wide hover:bg-[#2B2D42] transition-colors"
          >
            Get Free 3D Design
          </button>
        </form>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
          <button data-testid="products-cta-whatsapp" className="btn-ghost border-[#1A1F3D] text-[#1A1F3D] hover:bg-[#1A1F3D] hover:text-white">
            <MessageSquare size={20} />
            WhatsApp Us Now
          </button>
        </div>
      </div>
    </section>
  );
};

// Products Page Component
const Products = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div data-testid="products-page">
      <Navigation 
        scrolled={scrolled} 
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />
      <ProductsHeroSection />
      <ProductCategoriesGrid />
      <WardrobeShowcase />
      <KitchenShowcase />
      <OtherCategoriesGallery />
      <MaterialsLibrary />
      <PortfolioGallery />
      <ProductsCTASection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

// ==================== CONTACT PAGE COMPONENTS ====================

// Contact Section 1: Hero
const ContactHeroSection = () => {
  return (
    <section 
      data-testid="contact-hero-section" 
      className="relative min-h-[50vh] flex items-center justify-center bg-[#1A1F3D]"
    >
      <div className="container-custom relative z-10 text-center text-white pt-20 py-20">
        <h1 
          data-testid="contact-hero-headline"
          className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 animate-fade-in-up tracking-tight"
        >
          Let's Talk About Your Space
        </h1>
        <p 
          data-testid="contact-hero-subheadline"
          className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto animate-fade-in-up animation-delay-100"
        >
          Get in touch. We typically respond within 2 hours during business days.
        </p>
      </div>
    </section>
  );
};

// Contact Section 2: Quick Contact Cards
const QuickContactCards = () => {
  const contactMethods = [
    {
      icon: (
        <div className="relative">
          <div className="w-16 h-16 rounded-full bg-[#25D366] flex items-center justify-center border-3 border-[#C9A84C]">
            <svg viewBox="0 0 24 24" width="28" height="28" fill="white">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
          </div>
        </div>
      ),
      title: "WhatsApp",
      info: "+60 16-788 2088",
      description: "Click to chat instantly",
      href: "https://wa.me/60167882088",
      isExternal: true
    },
    {
      icon: (
        <div className="w-16 h-16 rounded-full bg-[#C9A84C]/10 flex items-center justify-center">
          <Mail size={28} className="text-[#C9A84C]" />
        </div>
      ),
      title: "Email",
      info: "hello@fitted.diy",
      description: "We reply within 24 hours",
      href: "mailto:hello@fitted.diy",
      isExternal: false
    },
    {
      icon: (
        <div className="w-16 h-16 rounded-full bg-[#C9A84C]/10 flex items-center justify-center">
          <MapPin size={28} className="text-[#C9A84C]" />
        </div>
      ),
      title: "Visit Us",
      info: "Skudai, Johor Showroom",
      description: "By appointment only",
      href: "#map",
      isExternal: false
    }
  ];

  return (
    <section data-testid="quick-contact-section" className="section-padding bg-white">
      <div className="container-custom">
        <div className="grid md:grid-cols-3 gap-8">
          {contactMethods.map((method, index) => (
            <a
              key={index}
              href={method.href}
              target={method.isExternal ? "_blank" : "_self"}
              rel={method.isExternal ? "noopener noreferrer" : ""}
              data-testid={`contact-card-${index}`}
              className="card-premium p-8 text-center hover:border-[#C9A84C] border-2 border-transparent transition-all group"
            >
              <div className="flex justify-center mb-6">
                {method.icon}
              </div>
              <h3 className="font-serif text-xl text-[#1A1F3D] font-bold mb-2">
                {method.title}
              </h3>
              <p className="text-[#C9A84C] font-semibold mb-1">{method.info}</p>
              <p className="text-[#8D99AE] text-sm">{method.description}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

// Contact Section 3: Contact Form
const ContactFormSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    need: '',
    budget: '',
    description: '',
    contactMethod: 'whatsapp'
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Contact form submitted:', formData);
    alert('Thank you for your enquiry! We will contact you shortly.');
    setFormData({
      name: '',
      phone: '',
      email: '',
      need: '',
      budget: '',
      description: '',
      contactMethod: 'whatsapp'
    });
  };

  return (
    <section data-testid="contact-form-section" className="section-padding bg-[#F8F6F1]">
      <div className="container-custom">
        <div className="grid lg:grid-cols-5 gap-12">
          {/* Form - Left Side (3 columns) */}
          <div className="lg:col-span-3">
            <div className="gold-line mb-6" />
            <h2 className="font-serif text-3xl sm:text-4xl text-[#1A1F3D] font-bold mb-8">
              Send Us an Enquiry
            </h2>
            
            <form onSubmit={handleSubmit} data-testid="contact-form" className="space-y-6">
              <div className="grid sm:grid-cols-2 gap-6">
                <div>
                  <label className="block text-[#2B2D42] font-medium mb-2">Name *</label>
                  <input
                    type="text"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    data-testid="contact-form-name"
                    className="w-full px-4 py-3 rounded-lg border border-[#EAEAEA] bg-white focus:outline-none focus:border-[#C9A84C] text-[#2B2D42]"
                    placeholder="Your name"
                  />
                </div>
                <div>
                  <label className="block text-[#2B2D42] font-medium mb-2">Phone Number *</label>
                  <input
                    type="tel"
                    required
                    value={formData.phone}
                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                    data-testid="contact-form-phone"
                    className="w-full px-4 py-3 rounded-lg border border-[#EAEAEA] bg-white focus:outline-none focus:border-[#C9A84C] text-[#2B2D42]"
                    placeholder="+60 16-788 2088"
                  />
                </div>
              </div>

              <div>
                <label className="block text-[#2B2D42] font-medium mb-2">Email</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  data-testid="contact-form-email"
                  className="w-full px-4 py-3 rounded-lg border border-[#EAEAEA] bg-white focus:outline-none focus:border-[#C9A84C] text-[#2B2D42]"
                  placeholder="your@email.com"
                />
              </div>

              <div className="grid sm:grid-cols-2 gap-6">
                <div>
                  <label className="block text-[#2B2D42] font-medium mb-2">What do you need?</label>
                  <select
                    value={formData.need}
                    onChange={(e) => setFormData({...formData, need: e.target.value})}
                    data-testid="contact-form-need"
                    className="w-full px-4 py-3 rounded-lg border border-[#EAEAEA] bg-white focus:outline-none focus:border-[#C9A84C] text-[#2B2D42]"
                  >
                    <option value="">Select an option</option>
                    <option value="wardrobe">Wardrobe</option>
                    <option value="kitchen">Kitchen</option>
                    <option value="tv-console">TV Console</option>
                    <option value="full-room">Full Room</option>
                    <option value="office">Office</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div>
                  <label className="block text-[#2B2D42] font-medium mb-2">Your Budget Range</label>
                  <select
                    value={formData.budget}
                    onChange={(e) => setFormData({...formData, budget: e.target.value})}
                    data-testid="contact-form-budget"
                    className="w-full px-4 py-3 rounded-lg border border-[#EAEAEA] bg-white focus:outline-none focus:border-[#C9A84C] text-[#2B2D42]"
                  >
                    <option value="">Select budget</option>
                    <option value="below-10k">Below RM 10,000</option>
                    <option value="10k-20k">RM 10,000 - 20,000</option>
                    <option value="20k-50k">RM 20,000 - 50,000</option>
                    <option value="50k+">RM 50,000+</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-[#2B2D42] font-medium mb-2">Brief Description</label>
                <textarea
                  rows={4}
                  value={formData.description}
                  onChange={(e) => setFormData({...formData, description: e.target.value})}
                  data-testid="contact-form-description"
                  className="w-full px-4 py-3 rounded-lg border border-[#EAEAEA] bg-white focus:outline-none focus:border-[#C9A84C] text-[#2B2D42] resize-none"
                  placeholder="Tell us about your project..."
                />
              </div>

              <div>
                <label className="block text-[#2B2D42] font-medium mb-3">Preferred Contact Method</label>
                <div className="flex flex-wrap gap-4">
                  {['whatsapp', 'call', 'email'].map((method) => (
                    <label 
                      key={method}
                      className="flex items-center gap-2 cursor-pointer"
                    >
                      <input
                        type="radio"
                        name="contactMethod"
                        value={method}
                        checked={formData.contactMethod === method}
                        onChange={(e) => setFormData({...formData, contactMethod: e.target.value})}
                        className="w-5 h-5 accent-[#C9A84C]"
                      />
                      <span className="text-[#2B2D42] capitalize">{method}</span>
                    </label>
                  ))}
                </div>
              </div>

              <button 
                type="submit"
                data-testid="contact-form-submit"
                className="btn-primary w-full sm:w-auto"
              >
                Send Enquiry
                <ArrowRight size={18} />
              </button>
            </form>
          </div>

          {/* Info - Right Side (2 columns) */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-2xl p-8 shadow-lg sticky top-28">
              {/* Logo */}
              <div className="flex items-center gap-3 mb-6">
                <Logo size={36} className="text-[#1A1F3D]" />
                <span className="font-serif text-3xl text-[#1A1F3D] font-bold">FITTED</span>
              </div>
              
              {/* Operating Hours */}
              <div className="mb-6">
                <h4 className="font-bold text-[#1A1F3D] mb-3 flex items-center gap-2">
                  <Clock size={18} className="text-[#C9A84C]" />
                  Operating Hours
                </h4>
                <p className="text-[#8D99AE] text-sm">Monday - Friday: 9:00 AM - 6:00 PM</p>
                <p className="text-[#8D99AE] text-sm">Saturday: 10:00 AM - 4:00 PM</p>
                <p className="text-[#8D99AE] text-sm">Sunday: By appointment</p>
              </div>

              {/* Response Guarantee */}
              <div className="mb-6 p-4 bg-[#F8F6F1] rounded-xl">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-[#C9A84C]/20 flex items-center justify-center">
                    <CheckCircle size={20} className="text-[#C9A84C]" />
                  </div>
                  <div>
                    <p className="font-bold text-[#1A1F3D] text-sm">Response Guarantee</p>
                    <p className="text-[#8D99AE] text-xs">We respond within 2 hours on business days</p>
                  </div>
                </div>
              </div>

              {/* Social Links */}
              <div>
                <h4 className="font-bold text-[#1A1F3D] mb-3">Follow Us</h4>
                <div className="flex gap-3">
                  <a href="#" className="w-10 h-10 rounded-full bg-[#1A1F3D] flex items-center justify-center text-white hover:bg-[#C9A84C] transition-colors">
                    <Instagram size={18} />
                  </a>
                  <a href="#" className="w-10 h-10 rounded-full bg-[#1A1F3D] flex items-center justify-center text-white hover:bg-[#C9A84C] transition-colors">
                    <Facebook size={18} />
                  </a>
                  <a href="#" className="w-10 h-10 rounded-full bg-[#1A1F3D] flex items-center justify-center text-white hover:bg-[#C9A84C] transition-colors">
                    <Youtube size={18} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Contact Section 4: Map
const MapSection = () => {
  return (
    <section id="map" data-testid="map-section" className="h-[400px] relative">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.4682767254!2d103.63416!3d1.5351!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da6c0e83b5e8e3%3A0x1234567890abcdef!2sTaman%20Perindustrian%20Jb%20Perdana%2C%2081300%20Skudai%2C%20Johor!5e0!3m2!1sen!2smy!4v1704067200000!5m2!1sen!2smy"
        width="100%"
        height="100%"
        style={{ border: 0, filter: 'grayscale(100%) contrast(1.1)' }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="FITTED Showroom Location"
      />
      <div className="absolute bottom-6 left-6 bg-white p-4 rounded-xl shadow-lg max-w-xs">
        <h4 className="font-bold text-[#1A1F3D] mb-1">FITTED Showroom</h4>
        <p className="text-[#8D99AE] text-sm">Industrial Park, 5, Jalan Satria 16, 81300 Skudai, Johor</p>
        <a 
          href="https://maps.google.com" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-[#C9A84C] text-sm font-medium hover:underline inline-flex items-center gap-1 mt-2"
        >
          Get Directions <ArrowRight size={14} />
        </a>
      </div>
    </section>
  );
};

// Contact Section 5: FAQ Accordion
const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "How long does production take?",
      answer: "Our standard production timeline is 3-5 weeks from design confirmation. Rush orders may be accommodated for an additional fee. We keep you updated throughout the process."
    },
    {
      question: "What materials do you use?",
      answer: "We use premium materials including high-grade laminate, solid wood veneer, melamine, and lacquer finishes. All hardware is sourced from trusted brands with soft-close mechanisms as standard."
    },
    {
      question: "Do you provide 3D designs?",
      answer: "Yes! We provide free 3D visualization for all projects. You'll see exactly how your furniture will look in your space before we begin production."
    },
    {
      question: "What's your warranty?",
      answer: "We offer a 2-year warranty covering manufacturing defects and hardware malfunction. Extended warranty options are available for long-term peace of mind."
    },
    {
      question: "Do you serve Singapore?",
      answer: "Currently, we focus on the Klang Valley and surrounding areas in Malaysia. Singapore service is planned for future expansion. Contact us for special arrangements."
    },
    {
      question: "What's the minimum order?",
      answer: "There's no strict minimum order. Whether you need a single wardrobe or a complete home fit-out, we're happy to help. Smaller projects start from RM 2,000."
    },
    {
      question: "How does pricing work?",
      answer: "Pricing is based on size, materials, and complexity. We provide detailed, transparent quotes with no hidden costs. What you see is what you pay."
    },
    {
      question: "Do you offer installment payment?",
      answer: "Yes, we offer flexible payment plans. Typically 50% deposit upon confirmation, 40% before delivery, and 10% upon completion. 0% installment plans are available for selected banks."
    }
  ];

  return (
    <section data-testid="faq-section" className="section-padding bg-white">
      <div className="container-custom max-w-4xl">
        <div className="text-center mb-12">
          <div className="gold-line mx-auto mb-6" />
          <h2 
            data-testid="faq-headline"
            className="font-serif text-3xl sm:text-4xl text-[#1A1F3D] font-bold"
          >
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              data-testid={`faq-item-${index}`}
              className="border border-[#EAEAEA] rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left bg-white hover:bg-[#F8F6F1] transition-colors"
              >
                <span className="font-semibold text-[#1A1F3D] pr-4">{faq.question}</span>
                {openIndex === index ? (
                  <ChevronUp size={20} className="text-[#C9A84C] flex-shrink-0" />
                ) : (
                  <ChevronDown size={20} className="text-[#C9A84C] flex-shrink-0" />
                )}
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5 text-[#8D99AE] leading-relaxed">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Contact Section 6: Social Media Links
const SocialMediaSection = () => {
  const socials = [
    { icon: <Instagram size={24} />, name: "Instagram", href: "#" },
    { icon: <Facebook size={24} />, name: "Facebook", href: "#" },
    { icon: <Youtube size={24} />, name: "YouTube", href: "#" },
    { icon: <Linkedin size={24} />, name: "LinkedIn", href: "#" },
  ];

  return (
    <section data-testid="social-media-section" className="py-16 bg-[#1A1F3D]">
      <div className="container-custom text-center">
        <p className="text-[#8D99AE] mb-6">Follow Our Journey</p>
        <div className="flex justify-center gap-4">
          {socials.map((social, index) => (
            <a
              key={index}
              href={social.href}
              data-testid={`social-link-${index}`}
              className="w-14 h-14 rounded-full bg-white flex items-center justify-center text-[#1A1F3D] hover:bg-[#C9A84C] hover:text-white transition-all"
              aria-label={social.name}
            >
              {social.icon}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

// Contact Section 7: Trust Signals
const TrustSignalsSection = () => {
  const signals = [
    { icon: <Star size={24} />, value: "4.9", label: "Google Rating" },
    { icon: <Users size={24} />, value: "500+", label: "Happy Customers" },
    { icon: <BadgeCheck size={24} />, value: "BNI", label: "Member" },
    { icon: <Shield size={24} />, value: "100%", label: "Satisfaction Guarantee" },
  ];

  return (
    <section data-testid="trust-signals-section" className="py-12 bg-[#F8F6F1]">
      <div className="container-custom">
        <div className="flex flex-wrap justify-center items-center gap-8 sm:gap-16">
          {signals.map((signal, index) => (
            <div 
              key={index}
              data-testid={`trust-signal-${index}`}
              className="text-center"
            >
              <div className="w-12 h-12 rounded-full bg-[#C9A84C]/10 flex items-center justify-center mx-auto mb-2 text-[#C9A84C]">
                {signal.icon}
              </div>
              <p className="font-serif text-2xl text-[#1A1F3D] font-bold">{signal.value}</p>
              <p className="text-[#8D99AE] text-sm">{signal.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Contact Section 8: Final CTA
const ContactFinalCTASection = () => {
  return (
    <section data-testid="contact-final-cta-section" className="py-20 sm:py-24 bg-[#C9A84C]">
      <div className="container-custom text-center">
        <h2 
          data-testid="contact-cta-headline"
          className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1A1F3D] font-bold mb-6"
        >
          Don't Wait. Let's Start Building.
        </h2>
        <p className="text-[#1A1F3D]/80 text-lg mb-10 max-w-2xl mx-auto">
          Your dream space is just a conversation away.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button 
            data-testid="contact-cta-quote"
            className="bg-[#1A1F3D] text-white px-8 py-4 rounded-lg font-semibold text-sm uppercase tracking-wide hover:bg-[#2B2D42] transition-colors inline-flex items-center justify-center gap-2"
          >
            Get Free Quote
            <ArrowRight size={18} />
          </button>
          <a 
            href="https://wa.me/60167882088"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-cta-whatsapp"
            className="bg-transparent border-2 border-[#1A1F3D] text-[#1A1F3D] px-8 py-4 rounded-lg font-semibold text-sm uppercase tracking-wide hover:bg-[#1A1F3D] hover:text-white transition-colors inline-flex items-center justify-center gap-2"
          >
            <MessageSquare size={18} />
            WhatsApp Us
          </a>
        </div>
      </div>
    </section>
  );
};

// Contact Page Component
const Contact = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div data-testid="contact-page">
      <Navigation 
        scrolled={scrolled} 
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />
      <ContactHeroSection />
      <QuickContactCards />
      <ContactFormSection />
      <MapSection />
      <FAQSection />
      <SocialMediaSection />
      <TrustSignalsSection />
      <ContactFinalCTASection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

// ==================== PRIVACY POLICY PAGE ====================
const PrivacyPolicy = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div data-testid="privacy-policy-page">
      <Navigation scrolled={scrolled} mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
      
      <section className="pt-32 pb-20 bg-[#1A1F3D]">
        <div className="container-custom text-center">
          <h1 className="font-serif text-4xl sm:text-5xl text-white font-bold">Privacy Policy</h1>
          <p className="text-[#8D99AE] mt-4">Last updated: January 9, 2026</p>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-custom max-w-4xl">
          <div className="prose prose-lg max-w-none text-[#2B2D42]">
            
            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">1. Introduction</h2>
            <p className="mb-4 leading-relaxed">
              FITTED ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website fitted.diy or engage with our services.
            </p>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">2. Information We Collect</h2>
            <h3 className="font-serif text-xl text-[#1A1F3D] font-bold mt-6 mb-3">Personal Information</h3>
            <p className="mb-4 leading-relaxed">We may collect personal information that you voluntarily provide, including:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Name and contact information (email, phone number, address)</li>
              <li>Project details and specifications you share with us</li>
              <li>Payment and billing information</li>
              <li>Communications you send to us</li>
            </ul>

            <h3 className="font-serif text-xl text-[#1A1F3D] font-bold mt-6 mb-3">Automatically Collected Information</h3>
            <p className="mb-4 leading-relaxed">When you visit our website, we may automatically collect:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Device information (browser type, operating system)</li>
              <li>IP address and location data</li>
              <li>Pages visited and time spent on our site</li>
              <li>Referring website addresses</li>
            </ul>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">3. How We Use Your Information</h2>
            <p className="mb-4 leading-relaxed">We use the information we collect to:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Provide, maintain, and improve our services</li>
              <li>Process your orders and transactions</li>
              <li>Communicate with you about projects, promotions, and updates</li>
              <li>Respond to your inquiries and provide customer support</li>
              <li>Analyze usage patterns to improve user experience</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">4. Information Sharing</h2>
            <p className="mb-4 leading-relaxed">
              We do not sell your personal information. We may share your information with:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Service providers who assist in our operations (payment processors, delivery partners)</li>
              <li>Professional advisors (lawyers, accountants) as needed</li>
              <li>Law enforcement when required by law</li>
            </ul>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">5. Data Security</h2>
            <p className="mb-4 leading-relaxed">
              We implement appropriate technical and organizational measures to protect your personal information. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
            </p>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">6. Your Rights</h2>
            <p className="mb-4 leading-relaxed">Under the Personal Data Protection Act 2010 (PDPA) Malaysia, you have the right to:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Access your personal data</li>
              <li>Correct inaccurate personal data</li>
              <li>Withdraw consent for data processing</li>
              <li>Request deletion of your data (subject to legal requirements)</li>
            </ul>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">7. Cookies</h2>
            <p className="mb-4 leading-relaxed">
              We use cookies and similar technologies to enhance your browsing experience. You can control cookie settings through your browser preferences.
            </p>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">8. Third-Party Links</h2>
            <p className="mb-4 leading-relaxed">
              Our website may contain links to third-party websites. We are not responsible for the privacy practices of these external sites.
            </p>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">9. Children's Privacy</h2>
            <p className="mb-4 leading-relaxed">
              Our services are not intended for individuals under 18 years of age. We do not knowingly collect personal information from children.
            </p>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">10. Changes to This Policy</h2>
            <p className="mb-4 leading-relaxed">
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last updated" date.
            </p>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">11. Contact Us</h2>
            <p className="mb-4 leading-relaxed">
              If you have questions about this Privacy Policy or our data practices, please contact us:
            </p>
            <div className="bg-[#F8F6F1] p-6 rounded-xl mt-4">
              <p className="mb-2"><strong>FITTED</strong></p>
              <p className="mb-2">Email: hello@fitted.diy</p>
              <p className="mb-2">Phone: +60 16-788 2088</p>
              <p>Address: Industrial Park, 5, Jalan Satria 16, Taman Perindustrian Jb Perdana, 81300 Skudai, Johor</p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

// ==================== TERMS OF SERVICE PAGE ====================
const TermsOfService = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div data-testid="terms-page">
      <Navigation scrolled={scrolled} mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
      
      <section className="pt-32 pb-20 bg-[#1A1F3D]">
        <div className="container-custom text-center">
          <h1 className="font-serif text-4xl sm:text-5xl text-white font-bold">Terms of Service</h1>
          <p className="text-[#8D99AE] mt-4">Last updated: January 9, 2026</p>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-custom max-w-4xl">
          <div className="prose prose-lg max-w-none text-[#2B2D42]">
            
            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">1. Agreement to Terms</h2>
            <p className="mb-4 leading-relaxed">
              By accessing or using FITTED's website (fitted.diy) and services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">2. Services Description</h2>
            <p className="mb-4 leading-relaxed">
              FITTED provides custom furniture design, manufacturing, and installation services in Malaysia. Our services include:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Custom wardrobe design and installation</li>
              <li>Kitchen cabinet design and installation</li>
              <li>TV consoles and feature walls</li>
              <li>Home office furniture</li>
              <li>Commercial fit-outs</li>
              <li>3D visualization and design consultation</li>
            </ul>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">3. Quotations and Pricing</h2>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>All quotations are valid for 30 days from the date of issue</li>
              <li>Prices are in Malaysian Ringgit (MYR) and include standard installation</li>
              <li>Additional charges may apply for complex installations, remote locations, or special requests</li>
              <li>Prices are subject to change based on material availability and market conditions</li>
            </ul>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">4. Orders and Payment</h2>
            <h3 className="font-serif text-xl text-[#1A1F3D] font-bold mt-6 mb-3">Payment Schedule</h3>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>50% deposit upon order confirmation</li>
              <li>40% before delivery/installation</li>
              <li>10% upon completion and inspection</li>
            </ul>
            <h3 className="font-serif text-xl text-[#1A1F3D] font-bold mt-6 mb-3">Payment Methods</h3>
            <p className="mb-4 leading-relaxed">
              We accept bank transfer, credit/debit cards, and approved installment plans through selected banks.
            </p>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">5. Production and Delivery</h2>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Standard production time is 3-5 weeks from design confirmation</li>
              <li>Delivery dates are estimates and subject to change due to unforeseen circumstances</li>
              <li>We will notify you of any delays as soon as possible</li>
              <li>Customer must ensure site is ready for installation on the agreed date</li>
            </ul>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">6. Design Approval</h2>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Customer must approve final 3D designs before production begins</li>
              <li>Changes requested after design approval may incur additional charges</li>
              <li>Changes requested after production begins may not be possible</li>
            </ul>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">7. Warranty</h2>
            <p className="mb-4 leading-relaxed">FITTED provides a 2-year warranty covering:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Manufacturing defects in materials and workmanship</li>
              <li>Hardware malfunction under normal use</li>
              <li>Structural integrity issues</li>
            </ul>
            <p className="mb-4 leading-relaxed">Warranty does not cover:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Damage caused by misuse, abuse, or accidents</li>
              <li>Normal wear and tear</li>
              <li>Damage from water, fire, or other external factors</li>
              <li>Modifications made by third parties</li>
              <li>Products not maintained according to our care instructions</li>
            </ul>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">8. Cancellation and Refunds</h2>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Cancellation before production: Full refund minus 10% administrative fee</li>
              <li>Cancellation after production starts: No refund (materials are custom-made)</li>
              <li>Refunds will be processed within 14 business days</li>
            </ul>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">9. Limitation of Liability</h2>
            <p className="mb-4 leading-relaxed">
              To the maximum extent permitted by law, FITTED shall not be liable for any indirect, incidental, special, or consequential damages arising from the use of our services. Our total liability shall not exceed the amount paid by you for the specific product or service.
            </p>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">10. Intellectual Property</h2>
            <p className="mb-4 leading-relaxed">
              All designs, 3D renderings, and content created by FITTED remain our intellectual property. Customers receive a license to use designs for their personal project only. Reproduction or commercial use without written permission is prohibited.
            </p>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">11. Customer Responsibilities</h2>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Provide accurate measurements and site information</li>
              <li>Ensure access to the installation site</li>
              <li>Inform us of any structural issues or concerns</li>
              <li>Clear the installation area before our team arrives</li>
            </ul>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">12. Dispute Resolution</h2>
            <p className="mb-4 leading-relaxed">
              Any disputes arising from these terms shall be governed by the laws of Malaysia. We encourage customers to contact us directly to resolve any issues before pursuing legal action.
            </p>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">13. Changes to Terms</h2>
            <p className="mb-4 leading-relaxed">
              We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to our website.
            </p>

            <h2 className="font-serif text-2xl text-[#1A1F3D] font-bold mt-8 mb-4">14. Contact Us</h2>
            <p className="mb-4 leading-relaxed">
              For questions about these Terms of Service, please contact us:
            </p>
            <div className="bg-[#F8F6F1] p-6 rounded-xl mt-4">
              <p className="mb-2"><strong>FITTED</strong></p>
              <p className="mb-2">Email: hello@fitted.diy</p>
              <p className="mb-2">Phone: +60 16-788 2088</p>
              <p>Address: Industrial Park, 5, Jalan Satria 16, Taman Perindustrian Jb Perdana, 81300 Skudai, Johor</p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
